<template>
  <div
    id="chatinput"
    style="bottom: 0; right: 0; left: 0"
    :style="{ position: isMobile ? 'fixed' : 'absolute' }"
  >
    <slot name="header"></slot>
    <div
      style="background: white; border-top: 1px solid #eee; position: relative"
      :style="{ 'padding-bottom': isiPad() && isIpadOnChrome() ? '50px' : '' }"
    >
      <div class="text-xs-center" v-if="app == 'whatsapp'">
        <small>{{ $t('whatsapp_send_messages_within_hours') }}</small>
      </div>

      <div
        v-if="is_blocked || is_leave_group"
        class="pa-3 text-xs-center"
        style="background: lightgray; color:#000"
      >
        {{ $t('Block') }}
      </div>
      <form v-on:submit.prevent="noop" v-else>
        <div
          class="text-xs-center"
          v-if="
            !$store.state.livechat.loadingUser &&
              $store.state.livechat &&
              !$store.state.livechat.sessiontoken &&
              user &&
              !user.group_id
          "
        >
          <small style="color:red">{{ $t('unable_to_send') }}</small>
        </div>

        <v-layout :style="{ 'flex-wrap': 'wrap' }" style="justify-content:space-between">
          <v-avatar size="30" class="ma-1">
            <img
              @error="onError"
              :src="
                selectedLivechatBot && selectedLivechatBot.pagelogo
                  ? selectedLivechatBot.pagelogo
                  : 'https://graph.facebook.com/' +
                    $store.state.livechat.pageid +
                    '/picture?width=100&height=100&SameSite=None'
              "
              style="border: 1px solid #eee"
            />
          </v-avatar>
          <v-flex class="pa-1">
            <autoresize-textarea
              v-if="$store.state.livechat.sessiontoken || user.group_id"
              ref="livechat_input"
              v-model="text"
              rows="1"
              placeholder="Type message"
              style="
                background: none;
                resize: none;
                border: 1px solid #eee;
                padding: 5px;
                border-radius: 5px;
                outline: 0px;
                display: inline-block;
                min-width: 100px;
                color: #000;
              "
              @pressEnter="onEnter"
              @onPaste="onPaste"
            ></autoresize-textarea>
            <autoresize-textarea
              v-else
              ref="livechat_input"
              :disabled="true"
              v-model="text"
              rows="1"
              placeholder="Type message"
              style="
                background: rgb(238, 238, 238);
                border: 1px solid #eee;
                padding: 5px;
                border-radius: 5px;
                outline: 0px;
                display: inline-block;
                min-width: 100px;
                color: #000;
              "
            ></autoresize-textarea>
          </v-flex>

          <v-flex shrink class="text-xs-right" style="white-space: nowrap">
            <!-- Facebook Conversion -->
            <span>
              <v-btn
                icon
                style="margin: 0"
                v-tooltip.top="'Create payment request'"
                @click="showFBConversion = true"
              >
                <baht-sign />
              </v-btn>
            </span>
            <!-- Send image -->
            <span>
              <uploadfile
                :disabled="!$store.state.livechat.sessiontoken && !user.group_id"
                ref="answer"
                v-model="image_url"
                @onUploaded="onUploaded"
                v-validate
                :multiple="true"
              ></uploadfile>
            </span>
            <span>
              <uploadalltype
                :disabled="!$store.state.livechat.sessiontoken && !user.group_id"
                ref="answer"
                v-model="file_url"
                @onUploaded="onUploadedFile($event)"
                :fileName.sync="fileName"
                v-validate
                :multiple="true"
              ></uploadalltype>
            </span>
            <span v-if="app == 'line'">
              <v-btn
                :disabled="!$store.state.livechat.sessiontoken && !user.group_id"
                icon
                style="margin: 0"
                v-tooltip.top="'Sticker'"
                @click="showSticker = true"
              >
                <v-icon class="outlined">face</v-icon>
              </v-btn>
            </span>

            <template v-if="selectedBot.theme == 'universalutilities'">
              <!-- Send reply message -->
              <span>
                <v-dialog v-model="showIntent" max-width="700">
                  <template v-slot:activator="{ on }">
                    <span>
                      <v-btn
                        :disabled="!$store.state.livechat.sessiontoken && !user.group_id"
                        icon
                        style="margin: 0"
                        v-tooltip.top="'Send'"
                        v-on="on"
                      >
                        <v-icon class="outlined">forum</v-icon>
                      </v-btn>
                    </span>
                  </template>
                  <v-card>
                    <div class="text-xs-right">
                      <v-btn @click="showIntent = false" fab flat color="primary" small>
                        <v-icon>close</v-icon>
                      </v-btn>
                    </div>
                    <v-card-text>
                      <intent
                        :key="$store.state.livechat.pageid"
                        :pageid="$store.state.livechat.pageid"
                        :showDefault="false"
                        :livechatapp="app"
                        :isLivechat="true"
                        @sendToLivechat="sendMessage"
                      ></intent>
                    </v-card-text>
                  </v-card>
                </v-dialog>
                <v-btn
                  depressed
                  fab
                  color="primary"
                  small
                  :disabled="!enableSend || (!$store.state.livechat.sessiontoken && !user.group_id)"
                  @click="clickSendBtn"
                  v-tooltip.top="
                    loadingLinePushMessageCount
                      ? 'Loading...'
                      : messageAvailableCount !== false
                      ? `จำนวนที่เคยส่ง ${messageAvailableCount} ข้อความ`
                      : 'Send'
                  "
                >
                  <i class="fa fa-send"></i>
                </v-btn>
              </span>
            </template>
            <template v-else>
              <span>
                <v-dialog v-model="showIntent" max-width="700">
                  <template v-slot:activator="{ on }">
                    <span>
                      <v-btn
                        :disabled="!$store.state.livechat.sessiontoken && !user.group_id"
                        icon
                        style="margin: 0"
                        v-tooltip.top="'Quick Message'"
                        v-on="on"
                      >
                        <v-icon class="outlined">forum</v-icon>
                      </v-btn>
                    </span>
                  </template>
                  <v-card v-if="showIntent">
                    <v-card-text>
                      <div class="text-xs-right">
                        <v-btn @click="showIntent = false" fab depressed color="primary" small>
                          <v-icon>close</v-icon>
                        </v-btn>
                      </div>
                      <intent
                        :key="$store.state.livechat.pageid"
                        :pageid="$store.state.livechat.pageid"
                        :showDefault="false"
                        :livechatapp="app"
                        :isLivechat="true"
                        :group_id="user.group_id"
                        @sendToLivechat="sendMessage"
                      ></intent>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </span>
              <span>
                <v-btn
                  ref="sendBtn"
                  depressed
                  fab
                  color="primary"
                  small
                  :disabled="!enableSend"
                  @click="clickSendBtn"
                  v-tooltip.top="'Send'"
                >
                  <i class="fa fa-send"></i>
                </v-btn>
              </span>
            </template>
          </v-flex>
        </v-layout>
      </form>

      <sticker-list v-model="showSticker" @sendSticker="sendSticker"></sticker-list>
      <fb-conversion-dialog v-model="showFBConversion" :userID="user.userid" @onSave="(message) => $emit('onSendMessage', message)"/>
    </div>
  </div>
</template>

<script>
import AutoresizeTextarea from './AutoresizeTextarea'
import { mapGetters } from 'vuex'
import Intent from '@/components/view/intent/Intent'
import uploadfile from '@/components/elements/UploadFileIcon'
import uploadalltype from '@/components/elements/UploadalltypeIcon'
import StickerList from '@/components/elements/StickerList'
import UploadSingleFile from '@/components/elements/UploadSingleFile.js'
import FBConversionDialog from '@/components/elements/FBConversionDialog'
import BahtSign from '@/components/icons/BahtSign'

import api from '@/api'

export default {
  props: ['value', 'app', 'is_leave_group', 'is_blocked', 'quote'],
  mixins: [UploadSingleFile],
  data: function() {
    return {
      type: 'text',
      text: '',
      enableSend: false,
      user: this.value,
      isMobile: false,
      showIntent: false,
      showUploadImg: false,
      image_url: null,
      showUploadFile: false,
      file_url: null,
      showSticker: false,
      fileName: null,
      showFBConversion: false,
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      linePushMessageCount: 'getLoadingLinePushMessageCount',
      loadingLinePushMessageCount: 'getLinePushMessageCount',
      botlist: 'botlist',
      selectedLivechatBot: 'selectedLivechatBot'
    }),
    welcomemessage() {
      let { messages, multichannel } = this.$store.getters.welcomeMessage(this.app)
      this.hasWCMultiChannel = multichannel
      return messages
    },
    isUnlock() {
      var bot = this.botlist.find(el => {
        return el.pageid == this.$store.state.livechat.pageid
      })
      if (!bot) return false
      return (
        (bot.pagetype == 'enterprise' && this.$store.state.livechatPageList.includes(bot.theme)) ||
        this.$store.state.livechatPageIdList.includes(bot.pageid) ||
        (bot.theme == 'ecommercebasic' && this.$store.state.livechat.pageid == '270028443161479') ||
        bot.isUnlockLivechat
      )
    },
    messageAvailableCount: function() {
      var vm = this
      if (vm.loadingLinePushMessageCount || vm.selectedBot.theme != 'universalutilities') {
        return false
      }
      var area = vm.linePushMessageCount.find(el => {
        return el.uu_areaname == vm.user.uu_areaname
      })
      if (area) {
        return area.count
      } else {
        return false
      }
    }
  },
  components: {
    AutoresizeTextarea,
    Intent,
    uploadfile,
    uploadalltype,
    StickerList,
    BahtSign,
    'fb-conversion-dialog': FBConversionDialog,
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  mounted: function() {
    var vm = this
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
    if (vm.selectedBot.theme == 'ecommercebasic') {
      vm.$store.dispatch('loadCategory').then(function() {
        vm.$store.dispatch('loadProducts')
      })
    }
  },
  methods: {
    isIpadOnChrome() {
      return (
        navigator.userAgent.indexOf('CriOS') >= 0 && navigator.userAgent.indexOf('Macintosh') >= 0
      ) // iOS&Chrome
    },
    async onPaste(evt) {
      const clipboardData = evt.clipboardData || evt.dataTransfer
      const items = clipboardData.items
      for (let index in items) {
        const item = items[index]
        if (item.kind === 'string') {
          if (clipboardData.getData('text') && clipboardData.getData('text').trim() != '') {
            const text = clipboardData.getData('text').trim()

            const cursorPosition = this.$refs['livechat_input'].$el.selectionStart
            this.text = [
              this.text.slice(0, cursorPosition),
              text,
              this.text.slice(cursorPosition)
            ].join('')
            evt.target.value = this.text
            await this.$nextTick()
            this.$refs['livechat_input'].$el.selectionEnd = cursorPosition + text.length
            this.enableSend = true
          } else {
            this.enableSend = false
          }
          return false
        } else if (item.kind === 'file') {
          const blob = item.getAsFile()
          const base64 = await this.renderImage(blob)
          if (base64.includes('data:application')) {
          } else {
            const result = await this.$swal.fire({
              title: 'Do you want to send this image?',
              html: `<img src="${base64}" style="max-height: 250px; max-width: 400px;">`,
              showCancelButton: true,
              confirmButtonText: this.$t('Confirm'),
              cancelButtonText: this.$t('cancel'),
              reverseButtons: true
            })

            if (result.value) {
              this.$store.dispatch('loading')
              try {
                const url = await this.validateFile([blob])
                if (url) {
                  this.onUploaded([url])
                }
              } catch (error) {
                console.error(error)
              }
              this.$store.dispatch('loading')
            }
          }
          return false
        }
      }
    },
    renderImage(blob) {
      return new Promise((resolve, reject) => {
        try {
          var reader = new FileReader()
          reader.onload = function(event) {
            resolve(event.target.result)
          }
          reader.readAsDataURL(blob)
        } catch (error) {
          reject(error)
        }
      })
    },
    clickSendBtn() {
      let text = this.text
      if (!text || text.trim() == '') {
        return false
      }
      let data = {
        a_val: JSON.stringify([[{ text: text, type: 'text' }]]),
        type: 'json'
      }
      this.sendMessage(data, { clearinput: true })
    },
    onEnter(event) {
      if (!this.isMobile) this.$refs.sendBtn.click()
      // recursive update
      // this.text = this.text + '\n'
    },
    sendSticker({ packageid, stickerid }) {
      let data = {
        a_val: `[[{ "stickerid": ${stickerid}, "type": "sticker", "packageid": ${packageid} }]]`,
        type: 'json'
      }

      this.sendMessage(data)
    },
    onUploadedFile(url) {
      this.enableSend = true
      var files = [[]]
      if (url) {
        url.forEach(el => {
          if (el) {
            let type = el.name.split('.').pop()
            let image_url = null
            if (type === 'pdf' || type === 'PDF') {
              image_url = 'https://cms.zwiz.app/static/img/assets/icon/pdf.png'
            } else if (type === 'xlsx' || type === 'xlsm' || type === 'xlsb' || type === 'xltx') {
              image_url = 'https://cms.zwiz.app/static/img/assets/icon/xls.png'
            } else if (type === 'docx' || type === 'dot' || type === 'dotm') {
              image_url = 'https://cms.zwiz.app/static/img/assets/icon/word.png'
            } else if (type === 'pptx' || type === 'pptm' || type === 'ppt') {
              image_url = 'https://cms.zwiz.app/static/img/assets/icon/powerpoint.png'
            } else {
              image_url = 'https://cms.zwiz.app/static/img/assets/icon/file.png'
            }
            if (el.url.indexOf('.mp4') != -1) {
              files[0].push({ source: el.url, type: 'video' })
            } else {
              files[0].push({
                data: [
                  {
                    buttons: [{ title: 'ดูไฟล์แนบ', type: 'web_url', url: el.url }],
                    image_url: image_url,
                    subtitle: el ? el.name : '',
                    title: ''
                  }
                ],
                ratio: 'square',
                type: 'generic',
                line_flex_custom_content: [
                  {
                    type: 'bubble',
                    size: 'nano',
                    hero: {
                      type: 'image',
                      url: image_url,
                      size: 'sm',
                      aspectRatio: '1:1.3',
                      aspectMode: 'fit',
                      margin: 'none',
                      align: 'center'
                    },
                    body: {
                      type: 'box',
                      layout: 'vertical',
                      contents: [
                        {
                          type: 'box',
                          layout: 'horizontal',
                          spacing: 'sm',
                          contents: [
                            {
                              type: 'text',
                              text: el ? el.name : '',
                              size: 'sm',
                              wrap: false,
                              color: '#000000',
                              maxLines: 1,
                              margin: 'xs'
                            }
                          ],
                          position: 'relative'
                        }
                      ],
                      position: 'relative',
                      margin: 'none',
                      justifyContent: 'center',
                      offsetTop: 'sm'
                    },
                    footer: {
                      type: 'box',
                      layout: 'vertical',
                      contents: [
                        {
                          type: 'button',
                          action: {
                            type: 'uri',
                            label: 'ดูไฟล์แนบ',
                            uri: el.url
                          },
                          color: '#4267B2',
                          position: 'relative',
                          margin: 'none',
                          height: 'sm',
                          offsetTop: 'none'
                        }
                      ],
                      spacing: 'none',
                      margin: 'none'
                    },
                    styles: {
                      footer: {
                        separator: true,
                        separatorColor: '#dddddd'
                      }
                    }
                  }
                ]
              })
            }
          }
        })
      }
      let data = {
        a_val: JSON.stringify(files),
        type: 'json'
      }

      this.sendMessage(data)
      this.file_url = null
      this.showUploadFile = false
    },
    onUploaded(url) {
      this.enableSend = true
      var images = [[]]
      if (typeof url == String) {
        images[0].push({ image_url: url, type: 'image' })
      } else {
        url.forEach(el => {
          images[0].push({ image_url: el, type: 'image' })
        })
      }
      let data = {
        a_val: JSON.stringify(images),
        type: 'json'
      }
      this.sendMessage(data)
      this.showUploadImg = false
      this.image_url = null
    },
    newline() {
      this.text = '${this.text}\n'
    },
    onError: function(event) {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    sendMessage: function(event, options) {
      let userid = options && options.userid ? options.userid : null
      this.showIntent = false
      // let isIntent = event && event.type == 'intent'
      let vm = this
      if (!vm.isUnlock) return false
      if (
        vm.enableSend == false &&
        vm.$store.state.livechat.pageid == null &&
        vm.$store.state.livechat.currentUser == null
      ) {
        return false
      }
      var bot = this.botlist.find(el => {
        return el.pageid == this.$store.state.livechat.pageid
      })
      if (!bot) return false

      let messages = event
      if (messages.context_out && (messages.context_out == '' || messages.context_out.trim() == ''))
        delete messages.context_out

      if (messages.type == 'json') {
        let a_val = null
        try {
          a_val = JSON.parse(messages.a_val)
          if (a_val && a_val.length > 0) {
            a_val = a_val[0]

            if (a_val[0] && this.quote) {
              const quoteToken = this.quote.message.message_id // Message ID is quote token from backend
              a_val[0]['quote_token'] = quoteToken
            }
          }
        } catch (error) {}

        if (a_val) {
          let welcome_message = []
          if (this.welcomemessage && this.welcomemessage.length > 0) {
            let rand = Math.floor(Math.random() * this.welcomemessage.length)
            welcome_message = this.welcomemessage[rand]
          }
          let hasMoreWelcome = true
          do {
            let index = a_val.findIndex(el => {
              return el.type == 'welcome_message'
            })

            if (index != -1) {
              a_val.splice(index, 1, ...welcome_message)
            } else hasMoreWelcome = false
          } while (hasMoreWelcome)

          messages.a_val = JSON.stringify([a_val])
        }
      }
      let data = {
        ...messages,
        group_id: vm.$store.state.livechat.currentUser.group_id,
        pageid: vm.$store.state.livechat.pageid,
        userid: userid || vm.$store.state.livechat.currentUser.userid || '',
        app: vm.$store.state.livechat.app,
        adminid: vm.$store.state.userid,
        messagetype: messages.type,
        messagevalue: messages.type == 'json' ? messages.a_val : vm.text,
        page_access_token: bot.page_access_token,
      }

      let message = {
        ...messages,
        answerby: 'admin',
        id: new Date().getTime(),
        messagedata:
          messages.type == 'json'
            ? JSON.parse(messages.a_val).length > 0
              ? JSON.stringify(JSON.parse(messages.a_val)[0])
              : messages.a_val
            : vm.text,
        messagetype: messages.type,
        pageid: vm.$store.state.livechat.pageid,
        timestamp: new Date(),
        userid: vm.$store.state.livechat.currentUser.userid
      }

      if (this.quote) {
        let allowReply = false
        
        if (messages.type === 'json') {
          const answerValue = JSON.parse(messages.a_val)
          
          if (answerValue[0] && answerValue[0][0]) {
            const _answerValue = answerValue[0][0]

            if (_answerValue.type === 'text') {
              allowReply = !_answerValue.text.startsWith('#')
            } else if (_answerValue.type === 'sticker') {
              allowReply = true
            }
          }
        }

        if (allowReply) {
          const { message: _message } = this.quote

          const questionType = `quote.${_message.questiontype}`

          data = {
            ...data,
            question_type: questionType,
            question_value: _message.questiondata
          }

          message = {
          ...message,
            questiontype: questionType,
            questiondata: _message.questiondata
          }
        }
      }

      
      vm.$emit('onSendMessage', message)
      if (options && options.clearinput) vm.text = ''

      api.sendMessage(data, function(error, response) {
        vm.enableSend = false
        if (error) {
          vm.$swal.fire({
            title: 'ไม่สามารถส่งข้อความได้',
            type: 'error',
            text: `${response.error_code} ${response.reason}`
          })
          return
        }
        if (
          response.responsecode != 200 ||
          _.get(response, 'reason.error.code', '') ||
          _.get(response, 'reason.error.message', '')
        ) {
          vm.$emit('onsetStatusError', message.id, response.reason.error.message)
          vm.$emit('emitSocket', {
            ...message,
            status: 'error',
            messagesError: response.reason.error.message
          })
        } else {
          vm.$emit('emitSocket', message)
        }
        if (messages.context_out || messages.userstatus || messages.usertags)
          vm.getUser(vm.$store.state.livechat.currentUser)
        vm.updateReadchat()
        if (vm.selectedBot.theme == 'universalutilities') {
          vm.$store.dispatch('loadLinePushMessageCount', {
            dateform: dayjs()
              .startOf('month')
              .format('YYYY-MM-DD'),
            dateto: dayjs()
              .endOf('month')
              .format('YYYY-MM-DD')
          })
        }
        // vm.$store.dispatch('loading')
      })
    },
    onResize() {
      this.isMobile = window.innerWidth < 960 || this.detectMob()
    },
    async getUser(user) {
      var data = {
        group_id: user.group_id,
        userid: user.userid,
        pageid: this.$store.state.livechat.pageid
      }
      return await this.$store.dispatch('getLivechatUser', data)
    },
    async updateReadchat() {
      var vm = this
      if (this.$aston.astonpages.includes(this.$store.state.livechat.pageid)) {
        var data = {
          adminid: this.$store.state.userid
        }
        if (user.userid) {
          data.userid = this.user.userid
          data.type = 'user'
        } else {
          data.userid = this.user.group_id
          data.type = 'group'
        }
        api.adminreadchat(data, async () => {
          await vm.$nextTick()
          vm.user.adminreply = true
          vm.$store.commit('SET_LIVECHAT_USER', vm.user)
          vm.$forceUpdate()
        })
      }
    }
  },
  watch: {
    text: function(newVal, oldVal) {
      if (newVal && newVal.trim() != '') {
        this.enableSend = true
      } else {
        this.enableSend = false
      }
    },
    value: function(newVal, oldVal) {
      this.user = this.value
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-chatinput.vue